window.addEventListener('DOMContentLoaded', function () {
  const rulesBtn = document.querySelector('.rules-popup-btn');
  const rulesCloseBtn = document.querySelector('.rules-popup-close');
  const rulesPopup = document.querySelector('.rules-popup');

  if (rulesPopup) {
    rulesBtn.addEventListener('click', function () {
      rulesPopup.classList.add('opened');
      rulesBtn.setAttribute('aria-expanded', true);
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
    });

    rulesCloseBtn.addEventListener('click', function () {
      rulesPopup.classList.remove('opened');
      rulesBtn.setAttribute('aria-expanded', false);
      document.body.style.overflow = 'visible';
      document.body.style.height = 'auto';
    });
  }
});
